import React, { Component } from 'react';
import './styles.css';
import PropTypes from 'prop-types';
import { MultiYearScalarType } from '../../types';
import ThreeYearsTableLayout from '../ThreeYearsTableLayout';
import BusinessPlanSubSectionTitle from '../BusinessPlanSubSectionTitle';
import range from 'lodash/range';
import LabelDescription from '../LabelDescription';
import OutputNumberUnit from '../OutputNumberUnit';

class ProcurementCosts extends Component {
	render() {
		const { Header, Row, Col, Label } = ThreeYearsTableLayout;
		const { game } = this.props;
		const { viewMode } = game;
		const {
			outsourcedProductionCosts,
			outsourcingDaysPayable
		} = game.procurement;

		const variables = [
			{
				id: 'outsourced-production-costs',
				value: outsourcedProductionCosts,
				unit: '€'
			},
			{
				id: 'outsourcing-days-payable',
				value: outsourcingDaysPayable,
				unit: 'days'
			}
		];
		return (
			<div className="procurement-overview">
				<BusinessPlanSubSectionTitle label={'procurement-costs-title'} />
				<ThreeYearsTableLayout>
					<Header />
					{variables.map(variable => (
						<Row key={variable.id}>
							<Label>
								<LabelDescription label={variable.id} />
							</Label>
							{range(1, 4).map(n => (
								<Col key={n}>
									<OutputNumberUnit
										active={!viewMode}
										variable={variable.value[n - 1]}
										unit={variable.unit}
									/>
								</Col>
							))}
						</Row>
					))}
				</ThreeYearsTableLayout>
			</div>
		);
	}
}

ProcurementCosts.propTypes = {
	game: PropTypes.shape({
		id: PropTypes.string.isRequired,
		viewMode: PropTypes.bool,
		procurement: PropTypes.shape({
			supplyNeedsBottles: MultiYearScalarType,
			supplyNeedsApples: MultiYearScalarType
		})
	})
};

export default ProcurementCosts;
